import { createId } from '@paralleldrive/cuid2';

<app-notification no-update key="notification" />

$ {
  let href;
  let fieldId;

  const { nextTo, isLoading } = state;
  const formId = createId();
}

<div class:no-update="has-text-centered mb-4">
  <h1 no-update class="title is-3">Forgotten Password</h1>
  $ href = nextTo ? `/login?next=${nextTo}` : '/login';
  Or <a no-update-body href=href>log into your account</a>
</div>

<div class:no-update="columns is-centered">
  <div class:no-update="column is-two-fifths">
    <app-box>
      <p no-update class="mb-4 has-text-justified">
        Enter your signup email below to receive instructions on how to reset your password.
      </p>
      <form key="form" id:scoped=formId method="post" accept-charset="utf-8" on-submit("onForgotFormSubmit")>
        <fieldset disabled=(isLoading && true)>
          <div no-update class="field forgot-field" aria-hidden="true">
            $ fieldId = createId();
            <input id:scoped=fieldId type="text" name=`forgot_${fieldId}` tabindex="-1" value="">
          </div>

          <div no-update class="field">
            $ fieldId = createId();
            <label class="label" for:scoped=fieldId>Email address</label>
            <div class="control">
              <input required
                class="input"
                id:scoped=fieldId
                type="email"
                inputmode="email"
                name="email"
                autocomplete="email"
                autofocus />
            </div>
          </div>
          <div class:no-update="field mt-4">
            <div class:no-update="control">
              <button no-update-body type="submit" class=["button is-dark is-capitalized is-login-button", isLoading && "is-loading"] form:scoped=formId>Send Reset Instructions</button>
            </div>
          </div>
        </fieldset>
      </form>
    </app-box>
  </div>
</div>
